module.exports = __webpack_public_path__ + "img/tishi.ea2559a5.png";